import React from 'react'

import './notification-box.scss'

const NotificationBox = ({copy}) => {

    return (
        <div className={copy ? "f-notification-box":""}>
            <p>{copy}</p>
        </div>
    )
}

export default NotificationBox
